module.exports = __webpack_public_path__ + "static/Cristian-Abril-fb747412c493c603428a1bc07706adf9.png";